import { message } from "antd";
import { useState } from "react";
import employeeService from "Services/AdminServices/Organization/EmployeeService";
import { useNavigate } from "react-router-dom";

export const useAlternativeCareerPaths = (employeeId) => {
  const navigate =  useNavigate();
  const [careerPaths, setCareerPaths] = useState([]);
  const [loadingCareerPaths, setLoadingCareerPaths] = useState(false);
  const [careerPathsLoaded, setCareerPathsLoaded] = useState(false);
  const [performanceReview, setPerformanceReview] = useState([]);
  const [loadingPerformanceReview, setLoadingPerformanceReview] = useState(false);
  const [supervisors, setSupervisors] = useState([]);
  const [loadingSupervisors, setLoadingSupervisors] = useState(false);
  const [selectedPath, setSelectedPath] = useState(null);
  const [selectedSupervisor, setSelectedSupervisor] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);

  const fetchAlternativeCareerPaths = async (employeeId) => {
    try {
      setLoadingCareerPaths(true);

      const data = await employeeService.getAlternativePaths(employeeId);
      console.log("career", data);
      setCareerPaths(data);
      setCareerPathsLoaded(true);
    } catch (error) {
      console.error("Error in fetching career paths", error);
    } finally {
      setLoadingCareerPaths(false);
    }
  };

  const fetchPerformanceReview = async (employeeId) => {
    try {
      setLoadingPerformanceReview(true);
      const data = await employeeService.getPreviousReview(employeeId);
      console.log("Performance", data);
      setPerformanceReview(data);
    } catch (error) {
      console.error("Error in fetching Performance Review", error);
    } finally {
      setLoadingPerformanceReview(false);
    }
  };

  const handleOpenModal = (path, employeeId) => {
    console.log("selectd path", path.id);
    console.log("selectd emp", employeeId);
    setSelectedPath(path);
    setSelectedSupervisor(null);
    setSelectedJob(null);
    setModalVisible(true);
    fetchSupervisors(employeeId, path.id);
  };

  const handleJobChange = (jobId) => {
  setSelectedJob(jobId);
  setSelectedSupervisor(null);
  setSupervisors([]);

  fetchSupervisors(employeeId, jobId); // ✅ updated call
};

  const fetchSupervisors = async (employeeId, jobTitleId) => {
    try {
      setLoadingSupervisors(true);
      console.log("job title", jobTitleId);
      const data = await employeeService.getSupervisors(employeeId, jobTitleId);
       console.log("Supervisors", data);
      setSupervisors(data);
    } catch (error) {
      console.error("Error in fetching Supervisors", error);
    } finally {
      setLoadingSupervisors(false);
    }
  };

  const handleSubmitTransition = async () => {
    if (!selectedSupervisor || !selectedJob) {
      message.warning("Please select supervisor and job role");
      return;
    }

    const payload = {
      employeeId: Number(employeeId),
      careerPathId: selectedPath.id,
      jobTitleId: selectedJob,
      supervisorId: selectedSupervisor,
    };

    try {
      console.log("payload", payload);
      await employeeService.createTransition(payload);

      message.success("Transition created successfully!");
      setModalVisible(false);
  
    navigate(`/employeeDetail/${employeeId}`, {
  state: {
    activeTab: "3",
    refresh: true,
  },
});
    } catch (error) {
      console.error("Failed to create transition");
    }
  };

  return {
    careerPaths,
    loadingCareerPaths,
    careerPathsLoaded,
    fetchAlternativeCareerPaths,

    loadingPerformanceReview,
    performanceReview,
    fetchPerformanceReview,

    // supervisors
    fetchSupervisors,
    loadingSupervisors,
    supervisors,

    // modal state
    selectedPath,
    setSelectedPath,
    selectedSupervisor,
    setSelectedSupervisor,
    selectedJob,
    setSelectedJob,
    modalVisible,
    setModalVisible,

    // actions
    handleOpenModal,
    handleSubmitTransition,
    handleJobChange
  };
};
